<template>
  <div style="position: absolute; top: 0; width: 100%; height: 100%; background: #f0f2f5" ref="contentData">
    <pcHeaders></pcHeaders>
    <div class="imgBg"><img src="@/assets/images/jitiBg.png" alt="" style="width: 100%; height: 250px" /></div>
    <div class="group_1">
      <div class="title_1">什么是集体报名？</div>
      <div class="text_1">
        集体报名是针对学校、企业、机构等集体单位推出的便捷报名模式，核心是为一定数量的特定人员（如学生、员工等）统一完成课程购买流程。集体购课简化报名流程，节省时间和精力，例如学校需要为
        100 名学生报名课程，无需学生各自在网站上单独操作，可通过集体报名方式完成。
      </div>
    </div>
    <div class="group_2">
      <div class="box_1">
        <div class="title_2">集体报名流程</div>
        <div class="title_3">四步轻松完成集体报名</div>
      </div>
      <div class="box_2">
        <div class="step">
          <div class="btn_1">第一步</div>
          <div class="text_2">下载并填写集体报名表</div>
          <div class="text_3">下载集体报名表，填写专业课名称并汇总人员信息，以“xx单位xx人”命名</div>
        </div>
        <div class="step">
          <div class="btn_1">第二步</div>
          <div class="text_2">提交报名表</div>
          <div class="text_3">将报名表发送至客服专员QQ：304839139或电话联系0551-62834200</div>
        </div>
        <div class="step">
          <div class="btn_1">第三步</div>
          <div class="text_2">确认报名信息与缴费</div>
          <div class="text_3">客服专员与单位报名负责人联系确认报名信息和费用，单位缴费后3个工作日左右由客服专员开通学习并通知单位</div>
        </div>
        <div class="step">
          <div class="btn_1">第四步</div>
          <div class="text_2">开具电子发票</div>
          <div class="text_3">客服专员与单位报名负责人确认开票信息，开票电子发票发送到指定邮箱</div>
        </div>
      </div>
      <div class="box_3">
        <div class="download_1">
          <div class="text_5">下载《集体报名表》模版</div>
          <div class="text_6">
            表格内容包含:
            <span style="color: #eb0000; font-weight: bold">姓名 身份证号码 单位所在地 单位名称 手机号码 所报课程 备注</span>
            （可不填）请按模板填写完整，确保信息准确，避免账号开通错误。
          </div>
          <div class="btn_2" @click="handledownload">点击下载Excel模版</div>
        </div>
        <div style="margin-left: 40px; margin-right: 40px">
          <img src="@/assets/images/Group 1171@2x.png" alt="" style="width: 36px; height: 128px" />
        </div>
        <div class="download_2">
          <img src="@/assets/images/table.png" alt="" style="width: 560px; height: 128px" />
          <div class="text_4">正确填写示例</div>
        </div>
      </div>
    </div>
    <div class="group_3">
      <div class="box_4">
        <div class="title_4">集体报名优势</div>
        <div class="title_5">体验高效便捷的批量报名服务</div>
      </div>
      <div class="box_5">
        <div class="box_9">
          <div class="info">
            <div class="text_7" style="margin-right: 62px">
              <div class="cicle"><span class="cicle_1"></span></div>
              节省90%时间
            </div>
            <div class="text_7" style="margin-right: 62px">
              <div class="cicle"><span class="cicle_1"></span></div>
              账号统一开通
            </div>
            <div class="text_7">
              <div class="cicle"><span class="cicle_1"></span></div>
              专属客服对接
            </div>
            <div class="text_7" style="margin-right: 62px">
              <div class="cicle"><span class="cicle_1"></span></div>
              享受集体优惠
            </div>
            <div class="text_7">
              <div class="cicle"><span class="cicle_1"></span></div>
              灵活增减学员
            </div>
            <div style="margin-left: 35px; margin-top: 10px">
              <img src="@/assets/images/jt.png" alt="" style="width: 446px; height: 226px" />
            </div>
          </div>
        </div>
        <div class="box_10">
          <div class="content">
            <div class="clicle_3"><img src="@/assets/images/gou (2).svg" alt="" /></div>
            管理员只需一次登记，无需100名学生逐一注册下单。
          </div>
          <div class="content">
            <div class="clicle_3"><img src="@/assets/images/gou (2).svg" alt="" /></div>
            平台后台批量创建账号，学生直接登录学习。
          </div>
          <div class="content">
            <div class="clicle_3"><img src="@/assets/images/gou (2).svg" alt="" /></div>
            一对一客服全程协助，解决所有购课问题。
          </div>
          <div class="content">
            <div class="clicle_3"><img src="@/assets/images/gou (2).svg" alt="" /></div>
            人数越多，折扣越大，专属客服为您核算最优价格。
          </div>
          <div class="content">
            <div class="clicle_3"><img src="@/assets/images/gou (2).svg" alt="" /></div>
            可随时调整学员名单，满足动态需求。
          </div>
        </div>
      </div>
      <div class="box_6">
        <div class="title_4">联系客服团队</div>
        <div class="title_5">我们随时为您提供专业的集体报名服务</div>
      </div>
      <div class="box_7">
        <a target="_blank" href="https://www.sobot.com/chat/pc/index.html?sysNum=ab2e331f1c2d41c4878fa99631b6f703">
          <div class="box_11">
            <img src="@/assets/images/Group 1196.svg" alt="" style="width: 41px; height: 50px" />
            <div style="margin-left: 16px">
              <div class="text_11">在线客服</div>
              <div class="text_12">点击立即发起在线咨询</div>
            </div>
          </div></a
        >
        <div class="box_11">
          <img src="@/assets/images/Group 1198.svg" alt="" style="width: 41px; height: 50px" />
          <div style="margin-left: 16px">
            <div class="text_11">电话联系</div>
            <div class="text_12">客服热线0551-62834200</div>
          </div>
        </div>
        <div class="box_11">
          <img src="@/assets/images/Group 1201.svg" alt="" style="width: 41px; height: 50px" />
          <div style="margin-left: 16px">
            <div class="text_11">微信联系</div>
            <div class="text_12">添加客服微信13965140450</div>
          </div>
        </div>
      </div>
    </div>
    <div class="group_4">
      <div class="box_8">
        <div class="title_4">常见问题解答</div>
        <div class="title_5">解答您在集体报名过程中可能遇到的疑问</div>
      </div>
      <zxdy></zxdy>
    </div>
    <pcBottom></pcBottom>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '../component/head.vue';
import pcBottom from '../component/bottom.vue';
import zxdy from './component/zxdy.vue';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom,
    zxdy
  },
  metaInfo() {
    return {
      title: this.title + '-安全生产学习平台',
      meta: [
        {
          charset: 'utf-8'
        },
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no'
        }
      ]
    };
  },
  data() {
    // 这里存放数据
    return {};
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    handledownload() {
      window.open('https://admin.ahsjxjy.com/excel/user/user_apply.xls', '_self');
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.group_1 {
  width: 100%;
  height: 250px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.title_1 {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  font-size: 28px;
  color: #333333;
  letter-spacing: 2px;
}
.text_1 {
  margin-top: 30px;
  width: 1200px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  letter-spacing: 1px;
}
.group_2 {
  width: 100%;
  height: 736px;
  background-color: #f4f6fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .box_1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .title_2 {
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 28px;
    color: #333333;
    letter-spacing: 2px;
  }
  .title_3 {
    margin-top: 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    letter-spacing: 1px;
  }
  .box_2 {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    .step {
      margin-right: 21px;
      width: 335px;
      height: 230px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      padding: 31px 43px;
      .btn_1 {
        width: 88px;
        height: 32px;
        background: rgba(64, 118, 246, 0.15);
        border-radius: 4px 4px 4px 4px;
        text-align: center;
        line-height: 32px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 14px;
        color: #4076f6;
        letter-spacing: 1px;
      }
      .text_2 {
        margin-top: 10px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: bold;
        font-size: 20px;
        color: #333333;
        letter-spacing: 2px;
      }
      .text_3 {
        margin-top: 16px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        letter-spacing: 1px;
      }
    }
  }
  .box_3 {
    width: 1430px;
    margin-top: 24px;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    .download_1 {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 691px;
      height: 230px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      .text_5 {
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: bold;
        font-size: 20px;
        color: #4076f6;
        letter-spacing: 2px;
      }
      .text_6 {
        margin-top: 16px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        letter-spacing: 1px;
        width: 590px;
      }
      .btn_2 {
           cursor:pointer;
        margin-top: 24px;
        width: 180px;
        height: 46px;
        background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
        border-radius: 6px 6px 6px 6px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 1px;
        text-align: center;
        line-height: 46px;
      }
    }
    .download_2 {
      padding: 24px 21px;
      width: 601px;
      height: 230px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .text_4 {
        margin-top: 23px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: bold;
        font-size: 20px;
        color: #c4c4c4;
        letter-spacing: 2px;
      }
    }
  }
}
.group_3 {
  width: 100%;
  height: 970px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .title_4 {
    margin-top: 10px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 20px;
    color: #333333;
    letter-spacing: 2px;
  }
  .title_5 {
    margin-top: 16px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    letter-spacing: 1px;
  }
  .box_4,
  .box_6 {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .box_5 {
    display: flex;
    margin-top: 72px;

    background: #ffffff;

    .box_9 {
      width: 564px;
      height: 374px;
      box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
      border-radius: 20px 20px 20px 20px;
      padding: 51px 39px 0 24px;
      .info {
        display: flex;

        flex-wrap: wrap;
        .text_7 {
          margin-bottom: 21px;
          display: flex;
          align-items: center;
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
          font-weight: bold;
          font-size: 16px;
          color: #333333;
          letter-spacing: 1px;
        }
        .cicle {
          margin-right: 3px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          width: 16px;
          height: 16px;
          background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);

          .cicle_1 {
            display: inline-block;
            width: 8px;
            height: 8px;
            background: #ffffff;
            border-radius: 50%;
          }
        }
      }
    }
    .box_10 {
      margin-left: 92px;
      width: 564px;
      height: 374px;
      padding-top: 92px;
      .content {
        margin-bottom: 20px;
        width: 564px;
        display: flex;
        align-items: center;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        .clicle_3 {
          margin-right: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 20px;
          height: 20px;
          background: #5674e6;
          border-radius: 50%;
          border: 1px solid #5674e6;
        }
      }
    }
  }
  .box_6 {
    margin-top: 90px;
  }
  .box_7 {
    display: flex;
    margin-top: 50px;
    .box_11 {
      margin-right: 55px;
      padding: 25px 0 0 110px;
      display: flex;
      width: 430px;
      height: 100px;
      background: #ffffff;
      box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);
      border-radius: 12px 12px 12px 12px;
      .text_11 {
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        letter-spacing: 1px;
      }
      .text_12 {
        margin-top: 5px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        letter-spacing: 1px;
      }
    }
  }
}
.group_4 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 140px;
  padding-top: 40px;
  background: #f4f6fa;
  .box_8 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .title_4 {
      margin-top: 10px;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: bold;
      font-size: 20px;
      color: #333333;
      letter-spacing: 2px;
    }
    .title_5 {
      margin-top: 16px;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: 400;
      font-size: 16px;
      color: #666666;
      letter-spacing: 1px;
    }
  }
}
</style>
